import _ from 'lodash'

export function safeInvokeFun(fn, ...args) {
    if (_.isFunction(fn)) {
        fn.apply(null, ...args)
    }
}

export function tryParseJson<T = any>(data: any): T {
    if (_.isString(data)) {
        try {
            return JSON.parse(data)
        } catch (e) {
            console.error(e)
            return data as any as T
        }
    }
    return data
}

export function forceJson<T = any>(data: unknown): T {
    if (_.isObject(data)) {
        return data as unknown as T
    }
    if (_.isString(data)) {
        try {
            return JSON.parse(data) as T
        } catch (e) {
            console.warn('Invalidate json ')
        }
    }
    console.warn('Invalidate json ')
    return {} as unknown as T
}
